function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { FilterType } from '@domain-group/fe-allhomes-search-api';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { ListingType, RentalType } from '@domain-group/fe-allhomes-library';
import AllhomesSearchMoreOptions, { ListFilter, PriceOption, AvailabilityDate, Keywords, SizeFilter } from '@domain-group/fe-co-allhomes-search-more-options';
import { jsx as ___EmotionJSX } from "@emotion/core";
var renderFilter = (filterType, filters, componentFunc) => filters.available().includes(filterType.name) && componentFunc(filters[filterType.name]);
var sortFeaturesByLabel = (first, second) => {
  if (first.label < second.label) {
    return -1;
  }
  if (first.label > second.label) {
    return 1;
  }
  return 0;
};
var rentalTypeFilter = _ref => {
  var btrEnabled = _ref.btrEnabled;
  var filterAvailable = availableTypes => btrEnabled ? availableTypes.map(type => _objectSpread(_objectSpread({}, type), type.name === RentalType.BUILD_TO_RENT.name ? {
    isNew: true
  } : {})) : availableTypes.filter(type => type.name !== RentalType.BUILD_TO_RENT.name);
  var filterSelected = selected => btrEnabled ? selected : selected.filter(type => type !== RentalType.BUILD_TO_RENT.name);
  return {
    filterAvailable,
    filterSelected
  };
};
var MoreOptions = _ref2 => {
  var filters = _ref2.filters,
    onChange = _ref2.onChange,
    onButtonClick = _ref2.onButtonClick,
    embedded = _ref2.embedded,
    visibilityPeriod = _ref2.visibilityPeriod;
  var _useAllhomesApi = useAllhomesApi(),
    _useAllhomesApi$toggl = _useAllhomesApi.toggledFeatures,
    toggledFeatures = _useAllhomesApi$toggl === void 0 ? {} : _useAllhomesApi$toggl;
  var btrEnabled = toggledFeatures.BUILD_TO_RENT;
  var _rentalTypeFilter = rentalTypeFilter({
      btrEnabled
    }),
    filterAvailable = _rentalTypeFilter.filterAvailable,
    filterSelected = _rentalTypeFilter.filterSelected;
  return ___EmotionJSX(AllhomesSearchMoreOptions, {
    onChange: onChange,
    onButtonClick: onButtonClick,
    embedded: embedded
  }, ListingType[filters.listingType] && !ListingType[filters.listingType].isCommercial && renderFilter(FilterType.availability, filters, value => ___EmotionJSX(AvailabilityDate, {
    value: value
  })), renderFilter(FilterType.listedPropertyTypes, filters, _ref3 => {
    var selected = _ref3.selected,
      available = _ref3.available;
    return ___EmotionJSX(ListFilter, {
      title: "Listing Type",
      name: "listedPropertyTypes",
      selected: filterSelected(selected),
      available: filterAvailable(available, {
        btrEnabled
      })
    });
  }), renderFilter(FilterType.propertyStatus, filters, _ref4 => {
    var selected = _ref4.selected,
      available = _ref4.available;
    return ___EmotionJSX(ListFilter, {
      title: "Property Status",
      name: "propertyStatus",
      selected: selected,
      available: available.map(each => ({
        name: each.name,
        label: (ListingType[filters.listingType] && ListingType[filters.listingType].isCommercial ? each.commercialLabel : each.residentialLabel).replace('%LISTING_VISIBILITY%', visibilityPeriod)
      }))
    });
  }), renderFilter(FilterType.saleMethods, filters, _ref5 => {
    var selected = _ref5.selected,
      available = _ref5.available;
    return ___EmotionJSX(ListFilter, {
      title: "Buying Options",
      name: "saleMethods",
      selected: selected,
      available: available
    });
  }), renderFilter(FilterType.onlyWithPrice, filters, value => ___EmotionJSX(PriceOption, {
    value: value
  })), renderFilter(FilterType.blockSize, filters, value => ___EmotionJSX(SizeFilter, {
    title: "Block Size",
    name: "blockSize",
    size: value
  })), renderFilter(FilterType.floorArea, filters, value => ___EmotionJSX(SizeFilter, {
    title: ListingType[filters.listingType] && ListingType[filters.listingType].isCommercial ? 'Net Lettable Area' : 'Floor Area',
    name: "floorArea",
    size: value
  })), ListingType[filters.listingType] && ListingType[filters.listingType].isCommercial && renderFilter(FilterType.availability, filters, value => ___EmotionJSX(AvailabilityDate, {
    value: value
  })), renderFilter(FilterType.listingFeatures, filters, _ref6 => {
    var selected = _ref6.selected,
      available = _ref6.available;
    return ___EmotionJSX(ListFilter, {
      title: "Features",
      name: "listingFeatures",
      selected: selected,
      available: available.slice().sort(sortFeaturesByLabel),
      twoColumn: true
    });
  }), renderFilter(FilterType.keywords, filters, value => ___EmotionJSX(Keywords, {
    value: value
  })));
};
MoreOptions.propTypes = {
  filters: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  visibilityPeriod: PropTypes.string,
  embedded: PropTypes.bool,
  onChange: PropTypes.func,
  onButtonClick: PropTypes.func
};
MoreOptions.defaultProps = {
  embedded: false,
  onChange: () => {},
  onButtonClick: () => {},
  visibilityPeriod: 'few weeks'
};
export default MoreOptions;